export enum DepartmentViewMode {
  Add = 'add',
  Edit = 'edit',
  ViewDetails = 'viewDetails',
  ViewMembers = 'viewMembers',
  ViewAccessGroups = 'viewAccessGroups',
  ViewTasks = 'viewTasks',
  ViewInterventions = 'viewInterventions',
}
